/**
 * Rolling-median "how slow is too slow" guardrail math — the ONE
 * implementation shared by the Add Tile trust strip (S6,
 * `components/add-tile/TrustStrip.tsx`, which warns `slow for Ns — Review`
 * when a chosen refresh interval is shorter than 5x the median preview
 * duration) and the issue-only health rail (S22, `services/healthSummary.ts`,
 * which flags a tile whose LAST run exceeded 5x its own rolling-median
 * duration). Reuse this; do not fork a second median/factor.
 */
export const median = (values: number[]): number => {
  if (values.length === 0) return 0;
  const sorted = [...values].sort((a, b) => a - b);
  const mid = Math.floor(sorted.length / 2);
  return sorted.length % 2 ? sorted[mid] : (sorted[mid - 1] + sorted[mid]) / 2;
};

/** A duration more than this many times the rolling median is flagged. */
export const REFRESH_GUARDRAIL_FACTOR = 5;
